export default {
  name: "ValueElement",
  props: {
    value: {
      type: [Number, String, null]
    },
    prepend: {
      type: String
    },
    append: {
      type: String
    }
  },
  computed: {
    formatedValue() {
      if (!this.value) return '-';
      // replace space with non-breaking space
      const formatted = this.value.toString().replace(/ /g, '\u00a0');
      return this.prepend ? `${this.prepend}${formatted}` : this.append ? `${formatted}${this.append}` : formatted;
    }
  }
};